import Vue from 'vue';

const success = (context, response) => {
  if (response.text) {
    context.textMessage = response.text.replace(/<br ?\/?>/ig, "\n");
  }
};

const failed = (context, error) => {
 if (error && error.response && error.response && error.response.data && error.response.data.msg) {
   context.textMessage = '';
   toastr.error(error.response.data.msg);
 }
};

export default (context, message) => {
  return Vue.$http.post('get-short-codes-replaced-text', message).then(response => {
      if(response && response.status === 200) {
        success(context, response.data);
      }
    }).catch(error => {
      failed(context, error);
    });
}



// WEBPACK FOOTER //
// ./src/app/services/message/getReplacedShortCodesText.js